/**
 * Created by lk on 17/6/4.
 */
import axios from "axios";
import https from "../../utils/http";
import { getToken, getAdminId } from "../../utils/auth";
let http = https.https;

// 权限管理

// 获取列表
export function authPermissionRuleList(query) {
    let querys = JSON.parse(JSON.stringify(query));
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    return axios({
        url: http + "/auth/permission_rule/index",
        method: "get",
        params: querys
    });
}

// 保存
export function authPermissionRuleSave(data, formName, method = "post") {
    let querys = JSON.parse(JSON.stringify(data));
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    let url =
        formName !== "edit"
            ? http + "/auth/permission_rule/save"
            : http + "/auth/permission_rule/edit";
    return axios({
        url: url,
        method: method,
        data: querys
    });
}

// 删除
export function authPermissionRuleDelete(data) {
    let querys = JSON.parse(JSON.stringify(data));
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    return axios({
        url: http + "/auth/permission_rule/delete",
        method: "post",
        data: querys
    });
}
